<form (ngSubmit)="onSubmit()" [formGroup]="form" class="pos-relative form">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <ng-container *ngIf="model">
    <div class="form-group my-15">
      <label class="form-label required">Name</label>
      <input [(ngModel)]="model.name" formControlName="name" type="text" class="form-control" required>
      <input-errors [control]="form.controls.name" [service]="validationService"></input-errors>
    </div>
    <div [hidden]="model.isLast" class="form-group my-15">
      <label class="form-label">SMS count</label>
      <input [(ngModel)]="model.smsCount" formControlName="smsCount" type="number" class="form-control" />
      <input-errors [control]="form.controls.smsCount" [service]="validationService"></input-errors>
    </div>
    <div class="form-group my-15">
      <label class="form-label">Rate</label>
      <input [(ngModel)]="model.rate" formControlName="rate" type="number" class="form-control" />
      <input-errors [control]="form.controls.rate" [service]="validationService"></input-errors>
    </div>
    <ng-container *ngIf="showButtons">
      <div *ngIf="showButtons" class="text-right buttons">
        <a href="javascript:history.back();" class="btn btn-danger m-b m-r">Cancel</a>
        <button id="btn-appscripts-payment-method-apply" type="submit" [disabled]="!form.valid" class="btn btn-primary m-b">Apply</button>
      </div>
    </ng-container>
  </ng-container>
</form>
